import { useBeforeUnload } from 'react-router-dom'
import { FormType } from '../types'
import { useCallback } from 'react'

export const useConfirmationBeforeUnload = (formType: FormType, isDirty: boolean) => {
  useBeforeUnload(
    useCallback((event: BeforeUnloadEvent) => {
    if (formType !== 'PROFILESHEET' || !isDirty) {
        return
    }

    event.preventDefault()
    }, [isDirty]),
    { capture: true }
  )
}
